import type { Tenant, TenantPath } from '../tenant.types';
import dayjs from 'dayjs';
import type { Dayjs } from 'dayjs';
import { CompanySimpleModel } from '@repositories/companyRepository/models/CompanySimpleModel';

export class TenantModel {
  private readonly _dto: Tenant;
  private readonly _subTenants: TenantModel[];
  private readonly _parentTenant?: TenantModel;
  private readonly _company?: CompanySimpleModel;
  private readonly _createdDate: Dayjs;
  private readonly _updatedDate: Dayjs;

  constructor(dto: Tenant) {
    this._dto = dto;
    this._subTenants = dto.subTenants ? dto.subTenants.map(tenant => new TenantModel(tenant)) : [];
    this._parentTenant = dto.parentTenant ? new TenantModel(dto.parentTenant) : undefined;
    this._company = dto.company ? new CompanySimpleModel(dto.company) : undefined;
    this._createdDate = dayjs(dto.createdDate) || dayjs();
    this._updatedDate = dayjs(dto.updatedDate) || dayjs();
  }

  get originDTO(): Tenant {
    return this._dto;
  }

  get id(): string {
    return this._dto.id || '';
  }

  get tenantCode(): string {
    return this._dto.tenantCode || '';
  }

  get description(): string {
    return this._dto.description ?? '';
  }

  get name(): string {
    return this._dto.name || '';
  }

  get level(): number {
    return this._dto.level || 0;
  }

  get properties(): Record<string, string> {
    return this._dto.properties ?? {};
  }

  get subTenants(): TenantModel[] {
    return this._subTenants;
  }

  hasParentTenant(): boolean {
    return !!this._parentTenant;
  }

  get parentTenant(): TenantModel | undefined {
    return this._parentTenant;
  }

  get tenantPath(): TenantPath | undefined {
    return this._dto.tenantPath;
  }

  isCompanyTenant() {
    return !!this._company;
  }

  get company() {
    return this._company;
  }

  get createdBy() {
    return this._dto.createdBy || '';
  }

  get createdDate() {
    return this._createdDate;
  }

  get updatedBy() {
    return this._dto.updatedBy || '';
  }

  get updatedDate() {
    return this._updatedDate;
  }

  get logoImageUrl() {
    return this._dto.logoImageUrl ?? '';
  }

  get currencyUnit() {
    return this._dto.currencyUnit ?? 'USD';
  }
}
